var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-text-field-character-counter",on:{"_init":_vm.onParentInit}},[_vm._v(" "+_vm._s(_vm.currentLength)+" / "+_vm._s(_vm.maxLength)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }